import { useSWRConfig } from 'swr';
import { patchFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { Availability } from '@/schemas/API/GET/employee/availability/response';
import type { CreateAvailability } from '@/schemas/API/POST/employee/availability/request';

const useUpdateAvailabilities = () => {
  const { mutate } = useSWRConfig();
  const { employeeId } = useParams<{ employeeId: string }>();

  const updateAvailabilities = async (
    availabilities: CreateAvailability[]
  ): Promise<Availability[] | undefined> => {
    if (employeeId === undefined)
      throw new Error('employeeId is undefined. Check URL.');

    await patchFetcher(
      `/employees/${employeeId}/availabilities`,
      availabilities
    );

    return await mutate(`/employees/${employeeId}/availabilities`);
  };

  return {
    updateAvailabilities,
  };
};

export default useUpdateAvailabilities;
